module.exports = __webpack_public_path__ + "img/heat-map.8e42bb05.svg";